import { render, staticRenderFns } from "./TrademarkDisclaimer.vue?vue&type=template&id=b76fd33a&"
import script from "./TrademarkDisclaimer.vue?vue&type=script&lang=js&"
export * from "./TrademarkDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports